import type { SimulatedPurchaseOrderRef } from "./simulationsList";

/** Una badge por número de OC; evita duplicados si el API trae varias filas iguales. */
export function uniquePurchaseOrderRefs(
  orders: SimulatedPurchaseOrderRef[],
): SimulatedPurchaseOrderRef[] {
  const seen = new Set<string>();
  const result: SimulatedPurchaseOrderRef[] = [];
  for (const po of orders) {
    const key = po.document_number?.trim() ? po.document_number.trim() : po.id;
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    result.push(po);
  }
  return result;
}
